var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpowermentthroughEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#0089E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 48.8727L40 54.7789L29.5 48.8727V42.6325L26.5 40.9658V50.6271L40 58.2209L53.5 50.6271V40.9658L50.5 42.6325V48.8727Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20.3103L19 31.1992V33.7992L40 45.4656L58 35.4659V43.75H61V31.1992L40 20.3103ZM55 33.7007L52 35.3673L40 42.0343L28 35.3673L25 33.7007L22.9207 32.5455L40 23.6896L57.0793 32.5455L55 33.7007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowermentthroughEducation);
export default __webpack_public_path__ + "static/media/EmpowermentthroughEducation.be149e8a6145e43bb3da8d4dd52a3eb5.svg";
export { ForwardRef as ReactComponent };